if (!customElements.get('bundle-offer')) {
  customElements.define(
    'bundle-offer',
    class BundleOffer extends HTMLElement {
      connectedCallback() {
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.button = this.querySelector('[data-bundle-submit]');

        this.radios.forEach((radio) => radio.addEventListener('change', () => this.applyQuantity(radio.value)));
        this.button?.addEventListener('click', () => this.submit());

        const checked = this.radios.find((r) => r.checked);
        if (checked) this.applyQuantity(checked.value, false);

        // Re-render tier prices when the variant changes (multi-variant products: size/colour priced differently)
        if (!this._unsub && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const d = event && event.data;
            if (!d || !d.html || (this.dataset.sectionId && d.sectionId !== this.dataset.sectionId)) return;
            const fresh = d.html.querySelector(`bundle-offer[data-section-id="${this.dataset.sectionId}"]`);
            if (!fresh) return;
            const current = this.radios.find((r) => r.checked)?.value;
            this.innerHTML = fresh.innerHTML;
            this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
            this.radios.forEach((radio) => {
              radio.checked = current ? radio.value === current : radio.checked;
              radio.addEventListener('change', () => this.applyQuantity(radio.value));
            });
            this.button = this.querySelector('[data-bundle-submit]');
            this.button?.addEventListener('click', () => this.submit());
            const sel = this.radios.find((r) => r.checked);
            if (sel) this.applyQuantity(sel.value, false);
          });
        }
      }

      disconnectedCallback() {
        this._unsub?.();
        this._unsub = null;
      }

      get quantityInput() {
        return document.querySelector('product-info input[name="quantity"]');
      }

      get mainSubmit() {
        return document.querySelector('product-info .product-form__submit');
      }

      applyQuantity(value, notify = true) {
        const input = this.quantityInput;
        if (!input) return;
        const qty = Math.max(1, parseInt(value, 10) || 1);
        input.value = qty;
        if (notify) input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      submit() {
        const checked = this.radios.find((r) => r.checked);
        if (checked) this.applyQuantity(checked.value);
        const submit = this.mainSubmit;
        if (!submit) return;
        if (submit.hasAttribute('disabled')) {
          submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        submit.click();
      }
    }
  );
}
